import Vimeo from '@vimeo/player';

/**
 * A video player class containing the Vimeo player and a property to indiciate if the player is ready
 */
export default class VideoPlayer {
	constructor(el) {
		this.el = el;
		this.parent = this.el.parentElement;
		this.chapterPartIndex = parseInt(this.el.closest('[data-chapter-part]').dataset.chapterPart, 10);
		this.ready = false;
		this.playing = false;
		this.waitingToPlay = false;

		this.breakpoint = window.matchMedia('(max-width:767px)');
		this.breakpointXL = window.matchMedia('(min-width:1439px)');
	}

	createPlayer() {
		let quality = this.breakpoint.matches ? '360p' : '720p';
		if(this.breakpointXL.matches) {
			quality = '1080p';
		}

		this.player = new Vimeo(this.el, {
			id: this.el.dataset.videoId,
			autopause: false,
			controls: false,
			dnt: true,
			keyboard: false,
			loop: true,
			muted: false,
			background: true,
			quality: quality,
		});

		this.player.ready().then(e => {
			this.ready = true;
		});

		this.player.on('play', e => {
			this.playing = true;
		});

		this.player.on('pause', e => {
			this.playing = false;
		});

		return this.player;
	}

	forceLoad() {
		return new Promise(async resolve => {
			try {
				await this.player.play();
				await this.player.pause();
			} catch (error) {
				console.error(error);
			}

			resolve();
		});
	}

	async play() {
		if (!this.ready) {
			return;
		}

		if (this.playing) {
			return;
		}

		if (this.waitingToPlay) {
			return;
		}

		try {
			this.waitingToPlay = true;
			await this.player.play();
			this.waitingToPlay = false;
		} catch (error) {
			console.error(error);
		}
	}

	async pause() {
		if (!this.ready) {
			return;
		}

		if (!this.playing) {
			return;
		}

		try {
			await this.player.pause();
		} catch (error) {
			console.error(error);
		}
	}
}
